import { Draft } from '@reduxjs/toolkit';

import { IProductData } from '../../index';

function removeFailure(draft: Draft<IProductData>) {
  draft.remove.config.isLoading = false;
}

export default removeFailure;
